import { useParams } from "react-router-dom";
import { ROUTE_PATH } from "../../contants/routePath";
import BreadcrumbItem from "./BreadcrumbItem";
import { Breadcrumbs } from "@mui/material";
import ArrowIcon from "../../assets/arrow-right.png";

const Breadcrumb = () => {
  const { id } = useParams();
  const breadcrumb = [
    <BreadcrumbItem key="home" navigateTo="/" title="Home" />,
    <BreadcrumbItem
      key="bound-adjustment"
      navigateTo={`plants/${id}${ROUTE_PATH.boundAdjustment}`}
      title="Bound Adjustment"
    />,
    <BreadcrumbItem
      key="permission"
      navigateTo={`plants/${id}${ROUTE_PATH.permissions}`}
      title="Permissions"
    />,
  ];
  return (
    <div className="my-4">
      <Breadcrumbs separator={<img src={ArrowIcon} />}>
        {breadcrumb}
      </Breadcrumbs>
    </div>
  );
};

export default Breadcrumb;
